import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top of the page whenever the path changes, except when the
 * URL contains a #anchor (in which case the browser handles the scroll).
 *
 * Also disables the browser's built-in scroll restoration so a page reload
 * always lands at the top, a hard requirement from the client because SPA
 * hydration can otherwise flash the wrong section before layout settles.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Runs once on mount: turn off browser scroll restoration and force top.
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // Some browsers (Safari on iOS) restore scroll AFTER first paint .
    // schedule a second reset once layout has stabilised.
    window.scrollTo(0, 0);
    const id = window.setTimeout(() => window.scrollTo(0, 0), 60);
    return () => window.clearTimeout(id);
  }, []);

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
